{
	"account": "Cuenta",
	"accountPlaceholder": "Seleccione una cuenta",
	"attachment": "Archivo adjunto",
	"billAttachmentSize": "Archivo demasiado grande (max 20 MB)",
	"billType": "Tipo",
	"billtypePlaceholder": "Seleccione un tipo",
	"costCenter": "Centro de coste",
	"costCenterPlaceholder": "Seleccione un centro de coste",
	"deleteBill": "¿Está seguro de que desea eliminar esta cuenta?",
	"description": "Descripción",
	"descriptionPlaceholder": "Introduzca una descripción",
	"dueDate": "Fecha de vencimiento",
	"invalidValue": "Valor no válido",
	"loading": "Cargando...",
	"observation": "Comentarios",
	"payDate": "Día de pago",
	"paymentMethod": "Método de pago",
	"paymentMethodPlaceholder": "Seleccione un método de pago",
	"paymentMethods": {
		"app": "App",
		"automaticDebit": "Débito automático",
		"bankTransfer": "Transferencia bancaria",
		"boleto": "Boleta bancaria",
		"check": "Cheque",
		"creditCard": "Tarjeta de crédito",
		"debitCard": "Tarjeta de débito",
		"money": "Efectivo",
		"promissory": "Pagaré"
	},
	"performDate": "Fecha de ejecución",
	"reconciled": "Reconciliado",
	"status": "Pagado",
	"supplier": "Proveedor",
	"supplierPlaceholder": "Seleccione un proveedor",
	"toPay": "Pagar",
	"toReceive": "A recibir",
	"validateField": "Campo obligatorio",
	"value": "Valor"
}
